export default __webpack_public_path__ + "static/media/Logo.522468fd.svg";